import preview from './index.vue'
const myPlugin = {}
let $vm = null
myPlugin.install = function (Vue, options, app) {
  app.preview = function () { //名称
    if (!$vm) {
      const el = document.createElement('div')
      const VueClass = Vue.extend(preview)
      document.querySelector('body').appendChild(el)
      $vm = new VueClass({
        el: el,
        propsData: options
      })
    }
    return $vm.show(...arguments)
  }
}

export default myPlugin

